module.exports = "<div class=\"sidebar\">\n  <app-sidebar-header></app-sidebar-header>\n  <app-sidebar-form></app-sidebar-form>\n  <app-sidebar-nav [navigation]=\"navigation\"></app-sidebar-nav>\n  <app-sidebar-footer></app-sidebar-footer>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/dfm/cryosoft/ui/src/app/components/app-sidebar/app-sidebar.component.html
// module id = ../../../../../src/app/components/app-sidebar/app-sidebar.component.html
// module chunks = main